import axios from "axios";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { baseURL } from "../../api/agent";
import store from "../store/store";
import { addProductSyncedEvent } from "../reducer/features/Integration/DmsSetupSlice";

export function storeMiddleware(store: any) {
  return (next: any) => (action: any) => {
    switch (action.type) {
      default:
    }

    return next(action);
  };
}

// export function signalRInit(callback: Function) {
//   hubConnection.onclose((error) => {
//     if (typeof error !== "undefined") {
//       console.log("(onclose) Error: " + error.name + " : " + error.message);
//     } else {
//       console.log("(onclose) No error to show while closing the connection.");
//     }
//     console.log("Hub connection closed");
//   });

//   hubConnection.onreconnecting((error) => {
//     console.log("Reconnecting to hub", error?.name + ":" + error?.message);
//   });

//   hubConnection.onreconnected((connectionId) => {
//     console.log("Connection to hub restored");
//   });

//   hubConnection.on("newMessage", (status: string) => {
//     console.log("msg receive");
//     console.log("Msg receive" + status);
//     //toast.info(status);
//   });
// }

// export function signalRClose() {
//   hubConnection.stop();
// }

export function signalRStart(setupId: string, callback: Function) {
  axios.post(`${baseURL}api/negotiate`).then((res: any) => {
    const hubConnection: HubConnection = new HubConnectionBuilder()
      .withUrl(`${res.data.url}`, {
        accessTokenFactory: () => res.data.accessToken,
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    hubConnection
      .start()
      .then(() => {
        console.log(
          "Connection to notification hub established",
          hubConnection
        );
        callback();
        hubConnection.on("synced-product", (response: any) => {
          console.log("event data", response.productAggregate);
          store.dispatch<any>(
            addProductSyncedEvent({
              productAggregate: response.productAggregate,
              isSyncing: response.isSyncing,
            })
          );
        });

        hubConnection.on("myMethodName", (response: any) => {
          console.log("msg receive");
          console.log(response);
        });

        axios
          .post(`${baseURL}api/JoinGroup`, {
            connectionId: hubConnection.connectionId,
            dmsSetupId: setupId,
          })
          .then((res) => {
            console.log("join group", setupId);
          });
      })
      .catch((error) => {
        console.log("Error establishing the connection to the Hub");
      });
  });
}
